import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AutoUnsubscribe } from '../../../common/decorators/auto-unsubscribe.decorator';
import { DelayTypeValue, ReportType } from '../../../store/models/profile-report';
import { TransportManagementReport } from '../../../store/state/monitoring/transport-management-profile/models/transport-management-report.model';
import { TransportManagementReportName } from '../../../store/state/monitoring/transport-management-profile/constants';
import { ShipmentReportName } from '../../../store/state/monitoring/shipment-planner-profile/constants/shipment-planner-profile-report.constant';
import { ShipmentProfileReport } from '../../../store';
import { IconNames } from '../../../common';

@Component({
  selector: 'ui-monitoring-report',
  templateUrl: './monitoring-report.component.html',
  styleUrls: ['./monitoring-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class MonitoringReportComponent implements OnChanges {
  @Input() reportForm: UntypedFormGroup;
  @Input() reportItemNameList: TransportManagementReportName[] | ShipmentReportName[];
  @Input() report: TransportManagementReport | ShipmentProfileReport;
  @Input() isSubscriptionEnabled: boolean;
  @Input() isDeviationVisible: boolean;
  @Input() maxFieldsCount: number;

  reportType = ReportType;
  delayTypeValue = DelayTypeValue;
  iconNameList = IconNames;

  ngOnChanges(changes: SimpleChanges): void {
    const subscriptionEnablingChanges = changes?.isSubscriptionEnabled;
    if (subscriptionEnablingChanges?.currentValue !== subscriptionEnablingChanges?.previousValue) {
      if (subscriptionEnablingChanges.currentValue) {
        this.reportForm.enable();
      } else {
        this.reportForm.disable();
        if (!subscriptionEnablingChanges.isFirstChange()) {
          this.reportForm.markAsDirty();
        }
      }
    }
  }
}
